import React from 'react'
import { Icon } from '../MainHome/Iconstyle';

export default function Icons({className}) {
    return <Icon className={className} />
}